import * as types from '../../actionTypes'

export const fetchingSubscriptions = () => ({
  type: types.FETCHING_SUBSCRIPTIONS,
})

export const fetchingSubscriptionsError = error => {
  return {
    type: types.FETCHING_SUBSCRIPTIONS_ERROR,
    error: error || 'Error fetching subscriptions',
  }
}

export const setSelectedSubscription = subscriptionId => {
  return {
    type: types.SET_SELECTED_SUBSCRIPTION,
    subscriptionId: subscriptionId,
  }
}

export const setSubscriptionsSuccess = data => {
  return {
    type: types.SET_SUBSCRIPTIONS_SUCCESS,
    subscriptions: data,
  }
}

export const replaceSubscription = subscription => {
  return {
    type: types.REPLACE_SUBSCRIPTION,
    subscription: subscription,
  }
}



// WEBPACK FOOTER //
// ./src/redux/css-admin/subscriptionManager/actions.js